const today = new Date()+1;
let yesterday = new Date();
yesterday.setDate(yesterday.getDate() - 1);
yesterday = new Date(yesterday.toISOString().split('T')[0]);

export const dateTime =  { '$gte' : yesterday, '$lte' : today };

